<template>
  <v-row
    v-if="terminalVendor && model"
    justify="center"
  >
    <v-dialog
      v-model="isVisible"
      :fullscreen="$vuetify.breakpoint.xsOnly"
      max-width="850"
      persistent
      scrollable
    >
      <v-card>
        <v-toolbar
          class="pl-1"
          flat
          height="80"
          max-height="80"
        >
          <v-avatar color="primary">
            <v-icon dark>
              mdi-credit-card-wireless
            </v-icon>
          </v-avatar>

          <v-toolbar-title class="pl-3">
            <div class="body-3">
              {{ $t('Settings.Payment.Edit.Toolbar.Title') }}
            </div>

            <div class="text-caption">
              {{ terminalVendor.Name }}
            </div>
          </v-toolbar-title>

          <v-spacer />

          <v-btn
            icon
            @click="onCancelButtonClick"
          >
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-divider />

        <v-card-text class="pa-1">
          <v-form
            ref="terminalVendorForm"
            v-model="terminalVendorFormValid"
            @submit.prevent
          >
            <v-container
              class=""
              fluid
            >
              <v-row
                v-if="terminalVendor.Code === TerminalVendorEnum.VIVA"
                dense
              >
                <v-col
                  class="font-weight-bold info--text"
                  cols="12"
                >
                  <v-btn
                    :href="model.Staging ? 'https://demo.vivapayments.com/selfcare/el/security/apiaccess' : 'https://www.vivapayments.com/selfcare/el/security/apiaccess'"
                    class="text-capitalize"
                    color="info"
                    small
                    target="_blank"
                    text
                  >
                    <v-icon left>
                      mdi-open-in-new
                    </v-icon>

                    Διαπιστευτήρια πρόσβασης
                  </v-btn>
                </v-col>

                <v-col
                  cols="12"
                  sm="6"
                >
                  <v-text-field
                    v-model="model.ApiMerchantId"
                    label="Merchant Id"
                    type="text"
                  />
                </v-col>

                <v-col
                  cols="12"
                  sm="6"
                >
                  <v-text-field
                    v-model="model.ApiMerchantKey"
                    label="Merchant Key"
                    type="text"
                  />
                </v-col>
              </v-row>

              <v-row dense>
                <v-col
                  v-if="terminalVendor.Code === TerminalVendorEnum.VIVA"
                  class="font-weight-bold info--text"
                  cols="12"
                >
                  <v-btn
                    :href="model.Staging ? 'https://demo.vivapayments.com/selfcare/el/security/apiaccess' : 'https://www.vivapayments.com/selfcare/el/security/apiaccess'"
                    class="text-capitalize"
                    color="info"
                    small
                    target="_blank"
                    text
                  >
                    <v-icon left>
                      mdi-open-in-new
                    </v-icon>

                    Διαπιστευτήρια POS APIs
                  </v-btn>
                </v-col>

                <v-col
                  cols="12"
                  sm="6"
                >
                  <v-text-field
                    v-model="model.Username"
                    label="Username"
                    type="text"
                  />
                </v-col>

                <v-col
                  cols="12"
                  sm="6"
                >
                  <v-text-field
                    v-model="model.Password"
                    label="Password"
                    type="text"
                  />
                </v-col>

                <template v-if="terminalVendor.Code === TerminalVendorEnum.VIVA">
                  <v-col
                    class="font-weight-bold info--text"
                    cols="12"
                  >
                    <v-btn
                      :href="model.Staging ? 'https://demo.vivapayments.com/selfcare/el/sources/paymentsources?sourceTypeId=466fe7e9-8bfc-45ae-816a-d10a8584d0ab' : 'https://www.vivapayments.com/selfcare/el/sources/paymentsources?sourceTypeId=466fe7e9-8bfc-45ae-816a-d10a8584d0ab'"
                      class="text-capitalize"
                      color="info"
                      small
                      target="_blank"
                      text
                    >
                      <v-icon left>
                        mdi-open-in-new
                      </v-icon>

                      Κωδικός Καταστήματος
                    </v-btn>
                  </v-col>

                  <v-col
                    cols="12"
                    sm="6"
                  >
                    <v-text-field
                      v-model="model.StoreSourceCode"
                      label="Store Source Code"
                      type="text"
                    />
                  </v-col>
                </template>

                <v-col
                  cols="12"
                  sm="6"
                >
                  <div class="d-inline-block ml-4">
                    <p class="grey--text text-caption ma-0">
                      Staging
                    </p>
                    <v-switch
                      v-model="model.Staging"
                      :label="model.Staging ? $t('Common.Button.Yes') : $t('Common.Button.No')"
                      class="ma-0"
                      color="purple"
                      inset
                    />
                  </div>
                </v-col>
              </v-row>

              <v-row
                v-if="terminalVendor.Code === TerminalVendorEnum.VIVA"
                dense
              >
                <v-col cols="12">
                  <div class="text-caption font-weight-bold">
                    Web Hooks
                  </div>
                  <v-divider />
                  <template v-for="(webhook, index) in terminalVendor.WebHooks[model.Staging ? 'sandbox' : 'live']">
                    <div
                      :key="`webhook-${index}`"
                      class="mt-2"
                    >
                      <div
                        :class="`${webhook.Color}--text`"
                        class="text-caption font-weight-bold"
                      >
                        {{ webhook.Label }}
                      </div>
                      <div class="text-caption">
                        <v-btn
                          :color="webhook.Color"
                          class="ma-0 text-lowercase"
                          small
                          text
                          @click="copyToClipboard(webhook.Url)"
                        >
                          <v-icon
                            color="primary"
                            left
                            small
                          >
                            far fa-copy
                          </v-icon>
                          <span class="grey--text text--darken-2">{{ webhook.Url }}</span>
                        </v-btn>
                      </div>
                    </div>
                  </template>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </v-card-text>

        <v-divider />

        <v-card-actions class="pa-4">
          <v-spacer />

          <v-btn
            class="light-blue--text text--darken-1"
            outlined
            @click="onCancelButtonClick"
          >
            {{ $t('Common.Button.Cancel').toLocaleUpperCase($i18n.locale) }}
          </v-btn>

          <v-btn
            :disabled="saving"
            :loading="saving"
            class="green white--text elevation-0"
            @click="onSaveButtonClick"
          >
            {{ $t('Common.Button.Save').toLocaleUpperCase($i18n.locale) }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import AppData from '@/mixins/appdata'
import Auth from '@/mixins/auth'
import TerminalVendorEnum from '@/api/Enums/TerminalVendorEnum'

export default {
  name      : 'TerminalVendorEditDialog',
  components: {},
  mixins    : [AppData, Auth],
  props     : {
    visible: {
      type   : Boolean,
      default: false
    },
    terminalVendor: {
      type   : Object,
      default: undefined
    }
  },
  data() {
    return {
      model                  : null,
      terminalVendorFormValid: false,
      saving                 : false
    }
  },
  computed: {
    TerminalVendorEnum() {
      return TerminalVendorEnum
    },
    isVisible: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      }
    }
  },
  watch: {
    visible(newVal) {
      this.saving = false
      if (newVal && this.terminalVendor) {
        if (this.terminalVendor.Code === TerminalVendorEnum.VIVA) {
          this.model = {
            Id  : this.terminalVendor?.Id || null,
            Code: this.terminalVendor?.Code || '',

            ApiMerchantId : this.terminalVendor?.ApiMerchantId || '',
            ApiMerchantKey: this.terminalVendor?.ApiMerchantKey || '',

            Username: this.terminalVendor?.Username || '',
            Password: this.terminalVendor?.Password || '',
            Staging : this.terminalVendor?.Staging ?? false,

            StoreSourceCode: this.terminalVendor?.StoreSourceCode || ''
          }
        }

        if (this.terminalVendor.Code === TerminalVendorEnum.MELLON) {
          this.model = {
            Id  : this.terminalVendor?.Id || null,
            Code: this.terminalVendor?.Code || '',

            Username: this.terminalVendor?.Username || '',
            Password: this.terminalVendor?.Password || '',
            Staging : this.terminalVendor?.Staging ?? false
          }
        }

        if (this.terminalVendor.Code === TerminalVendorEnum.EPAY) {
          this.model = {
            Id  : this.terminalVendor?.Id || null,
            Code: this.terminalVendor?.Code || '',

            Username: this.terminalVendor?.Username || '',
            Password: this.terminalVendor?.Password || '',
            Staging : this.terminalVendor?.Staging ?? false
          }
        }
      }
    }
  },
  created() {
  },
  mounted() {
  },
  updated() {
  },
  beforeDestroy() {
  },
  methods: {
    onSaveButtonClick() {
      this.$refs.terminalVendorForm.validate()

      if (this.terminalVendorFormValid) {
        this.saving = true
        this.$emit('terminal-vendor-save', this.model)
      }
    },

    onCancelButtonClick() {
      if (this.$refs.terminalVendorForm) this.$refs.terminalVendorForm.resetValidation()
      this.saving = false
      this.isVisible = false
    }
  }
}
</script>
